import React from "react";
import { FileDropzone } from "../../../../shared/components";

interface OrgInviteBulkDropzoneProps {
  onFileSelected: (file: File) => void;
  isProcessing: boolean;
}

export function OrgInviteBulkDropzone({
  onFileSelected,
  isProcessing,
}: OrgInviteBulkDropzoneProps) {
  const handleFileChange = (files: File | File[] | null) => {
    if (files && !Array.isArray(files)) {
      onFileSelected(files);
    }
  };

  const csvFileFilter = (file: File) => {
    return file.name.toLowerCase().endsWith(".csv");
  };

  return (
    <FileDropzone
      value={null}
      onChange={handleFileChange}
      instruction="Drop CSV file here or click to upload"
      subInstruction="CSV file should contain columns: email, name, role (admin|member)"
      accept=".csv"
      isDisabled={isProcessing}
      buttonText="Select CSV File"
      disabledButtonText="Processing..."
      fileFilter={csvFileFilter}
    />
  );
}
